import { render, staticRenderFns } from "./QuickbarTab.vue?vue&type=template&id=08b869b2&"
import script from "./QuickbarTab.vue?vue&type=script&lang=js&"
export * from "./QuickbarTab.vue?vue&type=script&lang=js&"
import style0 from "./QuickbarTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports